<template>
    <div class="mk-artwork-perspective row">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4 mx-auto px-0">
            <div style="margin-top: 20px;">
                <a
                    @click="dialog = true"
                    text
                    class="btn btn-white-outline-pill-opaque"
                >
                    About the piece
                </a>
            </div>

            <div class="[ perspective-divider ] my-4"></div>


            <!-- Share and sort -->
            <div class="d-flex justify-content-between">
                <div v-if="showComments" class="d-flex align-items-start">
                    <v-select
                        :items="ordering"
                        v-model="order"
                        @change="getData"
                        append-icon
                        class="[ text-select ] text-15 ml-3"
                        style="width: 70px; margin-left: 15px;"
                    ></v-select>
                    <i
                        class="fa-regular fa-chevron-down text-white"
                        style="margin-left: -7px; margin-top: 9px;"
                    ></i>
                </div>

                <div class="d-flex align-items-center cursor-pointer" @click="handleShare" style="padding-top: 2px; padding-right: 14px; height: 28px;">
                    <p class="mb-0 fs-700 text-15"><strong>Share </strong></p>
                    <i class="fa-sharp fa-solid fa-share text-white ml-2"></i>
                </div>
            </div>


            <!-- Comments -->
            <div v-if="showComments" style="border-top: 1px solid var(--color-border-grey);">
                <div
                    class="d-flex flex-column [ perspective-comment-wrap ]"
                    v-for="answer in answers"
                    :key="answer.id"
                >
                    <div style="width: 90%;">
                        <nl2br class="" tag="p" :text="answer.comment" />
                    </div>

                    <div class="d-flex justify-content-between">
                        <a
                            @click="handleLike(answer)"
                            class="btn btn-art-like ml-1"
                            :class="answer.has_liked ? 'art-is-liked' : 'art-not-liked'"
                        >
                            <span v-if="answer.num_likes <= 0" style="font-size:small; margin-right: 4px;">Like</span>
                            <span
                                v-else-if="answer.num_likes > 0 && answer.num_likes < 999"
                                class="text-white mr-1"
                                style="flex: 1; font-size:small;  margin-right: 2px;"
                            >{{answer.num_likes}}</span>
                            <span
                                v-else
                                class="text-white mr-1"
                                style="flex: 1; font-size:small;"
                            >{{nFormatter(answer.num_likes)}}</span>

                            <span v-if="answer.has_liked">
                                <img class="[ liked-icon ] img-fluid" src="/images/icons/eye-open.png" />
                            </span>
                            <span v-else>
                                <img class="[ liked-icon ] img-fluid" src="/images/icons/eye-closed.png" />
                            </span>
                        </a>

                        <a
                            @click="handleSharePerspective(answer)"
                            class="btn float-right"
                        >
                            <i class="fa-sharp fa-solid fa-share text-white ml-2"></i>
                        </a>
                    </div>

                </div>

                <div v-if="showLoadMore" class="mt-4 mb-4 text-center">
                    <h3 class="fw-700" ><u @click="loadMorePerspective" class="font-secondary cursor-pointer">load more perspectives</u></h3>
                </div>

            </div>



            <!-- About the piece dialog -->
            <v-dialog
                v-model="dialog"
                content-class="about-piece-dialog"
                max-width="428px"
                scrollable
                transition="scroll-x-transition"
                overlay-opacity="0.8"
                overlay-color="#000"
            >
                <v-card class="[ hf-dialog artist-dialog ]">
                    <v-card-title>
                        <div class="w-100 d-flex justify-content-between align-items-center" >
                            <button
                                @click="dialog = false"
                                class="btn btn-close-modal text-right w-100"
                                text
                            >
                                <i class="fa-thin fa-xmark text-white fa-xl"></i>
                            </button>
                        </div>
                    </v-card-title>

                    <v-card-text class="py-0">
                        <v-container class="admin-input-wrap">
                            <v-row>
                                <v-col cols="12" class="p-0">

                                    <div v-if="artwork.image_url" style="margin-bottom: 40px;">
                                        <img
                                            :src="artwork.image_url"
                                            class="img-fluid"
                                        />
                                    </div>

                                    <div>
                                        <p class="fs-16">About the piece</p>
                                        <h2 class="fs-24">{{ artwork.name }}</h2>
                                        <p class="fs-18">{{ artwork.size }}</p>

                                        <div class="mk-artwork-perspective-content" v-html="artwork.description"></div>
                                    </div>


                                    <div v-if="artwork.artist">
                                        <div
                                            style="margin-top: 40px; padding-top: 40px; padding-bottom: 24px; border-top: 1px solid var(--color-border-grey)" class="d-flex align-items-center justify-content-between">
                                            <div>
                                                <p class="fs-16">About the creator</p>
                                                <h2 class="fs-24" style="word-break: break-word;">{{ artwork.artist.name }}</h2>
                                                <p class="mb-0 fs-16">{{ (artwork.artist.born ? 'Born '+ artwork.artist.born + ', ' : '') + (artwork.artist.from ? artwork.artist.from : '') }}</p>
                                            </div>

                                            <div
                                                v-if="artwork.artist.image_url"
                                                class="[ about-artist-avatar ]"
                                                :style="`backgroundImage: url(${artwork.artist.image_url})`"
                                            >
                                                <!-- <img :src="artwork.artist.image_url" /> -->
                                            </div>
                                        </div>

                                        <div v-html="'<p>'+artwork.artist.bio+'</p>'"></div>

                                        <div style="margin-top: 24px; margin-bottom: 22px;">
                                            <a
                                                v-if="artwork.artist.website && artwork.artist.website != 'null'"
                                                target="_blank"
                                                :href="artistWebsite"
                                                class="[ btn-white-outline-pill ] d-inline-block"
                                            >More from the creator</a>
                                        </div>

                                        <div style="margin-top: 24px; margin-bottom: 22px;">
                                            <a
                                                v-if="artwork.artist.tipping_url && artwork.artist.tipping_url != 'null'"
                                                target="_blank"
                                                :href="artwork.artist.tipping_url"
                                                class="[ btn-white-outline-pill ] d-inline-block"
                                            >
                                                {{ (artwork.artist.tipping_text && artwork.artist.tipping_text != 'null') ? artwork.artist.tipping_text : 'Support me here' }}
                                            </a>
                                        </div>

                                    </div>
                                </v-col>
                            </v-row>

                        </v-container>
                    </v-card-text>


                </v-card>
            </v-dialog>


            <!-- Artwork share individual perspective -->
            <v-dialog
                v-model="dialogShareIndividual"
                content-class="about-piece-dialog"
                max-width="350px"
                scrollable
                transition="scroll-x-transition"
                overlay-opacity="0.8"
                overlay-color="#000"
            >
                <v-card class="[ hf-dialog artist-dialog ]" style="background-color: #000!important;">
                    <v-card-title>
                        <div class="w-100 d-flex justify-content-between align-items-center" >
                            <a
                                @click="dialogShareIndividual = false"
                                class="btn btn-close-modal text-right w-100"
                                text
                            >
                                <i class="fa-thin fa-xmark text-white fa-xl"></i>
                            </a>
                        </div>
                    </v-card-title>

                    <v-card-text class="py-0">
                        <v-container class="admin-input-wrap">
                            <v-row>
                                <v-col cols="12" class="p-0">

                                    <div class="bg-black-card pt-3 pl-3 pr-3 pb-1 mt-4 mb-4">
                                        <div>
                                            <div v-if="artwork.image_url">
                                                <img
                                                    :src="artwork.image_url"
                                                    class="img-fluid"
                                                    style="margin-bottom: 20px;"
                                                />
                                            </div>

                                            <div v-if="answer" class="text-center">
                                                <p class="text-white fs-16" style="line-height: 18px; margin-bottom: 0px;">"{{ answer.comment }}"</p>

                                                <p style="color: grey;">On "{{ artwork.name }}" <span v-if="artwork.artist">by {{ artwork.artist.name }}</span></p>
                                            </div>
                                        </div>

                                        <div style="margin-top: 30px;" class="text-right">
                                            <span class="text-white" style="font-size: 11px;">
                                                artsight.art
                                            </span>
                                            <img
                                                style="max-height: 20px; margin-right: -10px; margin-bottom: 3px;"
                                                src="/images/branding/logo-artsight-branding.png"
                                            />
                                        </div>
                                    </div>

                                    <div class="mt-2" style="margin-bottom: 50px;">
                                        <center>
                                            <div v-if="artwork.image_url">
                                                <a
                                                    :href="'/a/'+artwork.uuid+'/download/'+answer.id"
                                                    @click="$event.target.blur()"
                                                >
                                                    <button class="btn btn-art-like art-is-liked ml-2 mb-3">
                                                        <span class="text-white mr-2 fs-16" @click="$event.target.blur()">
                                                            Save perspective
                                                        </span>
                                                        <i class="fa-regular fa-download text-white"></i>
                                                    </button>
                                                </a>
                                            </div>
                                                <a style="outline: none !important; width:52% !important; text-align: center;" class="btn btn-art-like art-is-liked ml-2 mb-3" @click="handleShare">
                                                    <span style="text-align: center;" class="text-white fs-16">
                                                        Copy page link
                                                    </span>
                                                    <i class="fa-sharp fa-solid fa-share text-white ml-2"></i>
                                                </a>
                                        </center>
                                    </div>

                                </v-col>
                            </v-row>

                        </v-container>
                    </v-card-text>


                </v-card>
            </v-dialog>
        </div>
    </div>
</template>





<style>

.perspective-comment-wrap {
    padding: 24px 0;
    border-bottom: 1px solid var(--color-border-grey);
}

.perspective-comment-wrap p {
    font-size: 18px !important;
}

.btn-art-like {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 11px;
    font-size: 15px !important;
    line-height: 16px;
    background-color: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 25px;
}

.btn-art-like.art-is-liked {
    color: #fff;
    border: none;
}

.text-15 {
  font-size: 15px !important;
}

.btn-art-like.art-not-liked {
    color: var(--black-200-placeholder) !important;
    border: none;
    font-size: 15px !important;
}

.about-artist-avatar {
    height: 112px;
    width: 112px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
    border-radius: 50%;
}

.artist-dialog {
    padding-top: 24px;
}

.artist-dialog .v-card__title > div {
    border-bottom: none;
}

.artist-dialog blockquote {
    padding-left: 15px;
    border-left: 3px solid white;
}

@media only screen and (max-width: 400px) {
    .about-piece-dialog {
        min-height: 100vh;
        margin: 0;
    }
}

.liked-icon {
    height: 24px;
    width: 24px;
}

.swal-art-header {

}

.swal-art-title {
    display: none !important;
}

.swal-art-html-container {
    color: var(--color-white) !important;
}

.swal-art-popup {
    background-color: var(--black-500-hover) !important;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1) !important;
}

.text-select .v-select__slot .v-select__selections {
    justify-content: flex-start!important;
}

</style>





<script>
import axios from 'axios';

export default {
    props: {
        artwork: {
            type: Object,
        },
    },
    mounted() {
        if(this.artwork && !this.artwork.is_comment_enabled) {
            this.showComments = false;
        } else {
            this.getData();
        }
    },
    computed: {
        artistWebsite: function () {
            if(this.artwork.artist.website && this.artwork.artist.website != 'null') {
                let link = this.artwork.artist.website;
                return !/^https?:\/\//i.test(link) ? `http://${link}` : link;
            } else {
                return '';
            }
        },
  },
    data() {
        return {
            order: 'Admired',
            ordering: ['Admired', 'Newest'],
            answers: {},
            answer: '',
            page: 1,
            defaultPerPage: 9,
            itemsPerPage: 9,
            dialog: false,
            showComments: true,
            showLoadMore: false,
            dialogShareIndividual: false
        };
    },
    methods: {
        async getData() {
            await axios
                .get('/api/v1/frontend/artwork_answers?filter[artwork_id]='+this.artwork.id+'&filter[is_published]=1'
                    +'&page='+this.page+'&limit='+this.itemsPerPage+'&sort='+this.order
                )
                .then((response) => {
                    this.answers = response.data.data;

                    if(response.data.last_page > 1) {
                        this.showLoadMore = true;
                    } else {
                        this.showLoadMore = false;
                    }
                })
                .catch(function (e) {
                    if (e.response.status == 422) {
                        var errorText = "";
                        if (e.response.data.errors) {
                        Object.entries(e.response.data.errors).forEach(([key, value]) => {
                            value.forEach((errorMessage) => {
                            errorText += "" + errorMessage + " <br>";
                            });
                        });
                        } else {
                        errorText += e.response.data.message;
                        }
                        Vue.swal("", errorText, "error");
                        return e.response;
                    } else if(e.response.status == 413) {
                        Vue.swal("", "Server Error Request Entity Too Large", "error");
                    } else {
                        Vue.swal("", "Server error", "error");
                    }
                });
        },

        async handleLike(answer) {
            await axios
                .post('/api/v1/frontend/answer_likes', {
                    artwork_answer_id: answer.id
                })
                .then((response) => {
                    // Vue.swal({
                    //     title: " ",
                    //     text: "Saved",
                    //     icon: "success",
                    //     toast: true,
                    //     position: "top-end",
                    //     timer: 2000,
                    //     showConfirmButton: false,
                    // });

                    this.getData();
                })
                .catch(function (e) {
                    if (e.response.status == 422) {
                        var errorText = "";
                        if (e.response.data.errors) {
                        Object.entries(e.response.data.errors).forEach(([key, value]) => {
                            value.forEach((errorMessage) => {
                            errorText += "" + errorMessage + " <br>";
                            });
                        });
                        } else {
                        errorText += e.response.data.message;
                        }
                        Vue.swal("", errorText, "error");
                        return e.response;
                    } else if(e.response.status == 413) {
                        Vue.swal("", "Server Error Request Entity Too Large", "error");
                    } else {
                        Vue.swal("", "Server error", "error");
                    }
                });
        },

        // Share button/copy to clipboard
        handleShare() {
            navigator.clipboard.writeText(this.artwork.qr_code_link);
            Vue.swal({
                /*
                If client wants to disable wiggle animation
                showClass: {
                    backdrop: 'swal2-noanimation', // disable backdrop animation
                    popup: '',                     // disable popup animation
                    icon: ''                       // disable icon animation
                },
                */
                title: " ",
                text: "Copied to clipboard",
                customClass: {
                    container: 'swal-art-container',
                    popup: 'swal-art-popup',
                    header: 'swal-art-header',
                    title: 'swal-art-title',
                    htmlContainer: 'swal-art-html-container',
                },
                iconHtml: "<i class='fa-light fa-circle-check fa-xs' style='color: #ffffff;'></i>",
                width: "100%",
                toast: true,
                position: "top",
                timer: 3000,
                showConfirmButton: false,
            });
        },

        handleSharePerspective(answer) {
            this.answer = answer;
            this.dialogShareIndividual = true;
        },

        async loadMorePerspective() {
            this.itemsPerPage += this.defaultPerPage;
            this.getData();
        },

        nFormatter(num) {
            // https://stackoverflow.com/questions/9461621/format-a-number-as-2-5k-if-a-thousand-or-more-otherwise-900 - Using Yash's answer
            if (num >= 1000000000) {
                return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
            }
            if (num >= 1000000) {
                return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
            }
            if (num >= 1000) {
                return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
            }
            return num;
        }

    }
};
</script>
